/* rastah-collgift-sync v6
   Reconciler for Collection/Spend gift offers (metaobject
   rastah_collection_gift_offer). Runs alongside the Buy-2-Get-1
   engine; only touches lines carrying its own offer handle
   (prefixed "coll-") in the shared _rastah_gwp property.

   v6 - NO CURRENCY CONVERSION. v2-v5 scaled the threshold by
   Shopify.currency.rate. That rate does not describe this store:
   the PK market uses its own price list (a $300 tapestry is priced
   Rs.71,900, ~240x, while Shopify.currency.rate reports ~42x), so
   the converted threshold was simply wrong and the bar could never
   reach it. min_spend is now authored in the CUSTOMER'S currency
   and compared directly against cart.js line totals - no maths, no
   drift, what the merchant types is what the customer must spend.

   Carried over: session-durable state, quantity lock, no double
   gifts, never acts on incomplete collection data, respects
   customer removal, charge guard, parallel cart refresh. */
(function () {
  'use strict';
  var CFG = 'script[data-rastah-collgift-config]';
  var PROP = '_rastah_gwp';
  var MAX_ADDS = 2, TTL = 600000, PAGES = 20, COOLDOWN = 2000;
  var SKEY = 'rastah_collgift_state';
  var QC_HOST = '#shopify-section-quick-cart';
  var QC_PARTS = ['.quick-cart__items', '.quick-cart__footer', '.quick-cart__heading'];
  var busy = false, queued = false, members = {}, lastAddAt = 0;

  function loadState() {
    try {
      var raw = sessionStorage.getItem(SKEY);
      if (raw) {
        var s = JSON.parse(raw);
        if (s && typeof s === 'object') return { blocked: s.blocked || [], adds: s.adds || {}, dismissed: s.dismissed || {}, seen: s.seen || {} };
      }
    } catch (e) {}
    return { blocked: [], adds: {}, dismissed: {}, seen: {} };
  }
  var ST = loadState();
  function saveState() { try { sessionStorage.setItem(SKEY, JSON.stringify(ST)); } catch (e) {} }
  window.__rastahCollBlocked = ST.blocked;
  window.__rastahCollStalled = window.__rastahCollStalled || {};

  /* threshold is already in the customer's currency, in cents */
  function minFor(o) { return o.min_spend || 0; }

  function offers() {
    var el = document.querySelector(CFG);
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function block(handle) {
    if (ST.blocked.indexOf(handle) === -1) ST.blocked.push(handle);
    saveState();
    var el = document.querySelector(CFG);
    if (el) {
      try {
        var l = JSON.parse(el.textContent) || [];
        var n = l.filter(function (x) { return x.handle !== handle; });
        if (n.length !== l.length) el.textContent = JSON.stringify(n);
      } catch (e) {}
    }
    document.querySelectorAll('[data-gwp-offer="' + handle + '"]').forEach(function (n) { n.remove(); });
  }
  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }
  function ours(it) { return !!(it.properties && Object.prototype.hasOwnProperty.call(it.properties, PROP)); }

  function refreshDrawer() {
    var host = document.querySelector(QC_HOST);
    if (!host) return Promise.resolve();
    return fetch('/?section_id=quick-cart', { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        QC_PARTS.forEach(function (sel) {
          var f = doc.querySelector(sel), l = host.querySelector(sel);
          if (!f || !l || f.innerHTML === l.innerHTML) return;
          l.innerHTML = f.innerHTML;
        });
      }).catch(function () {});
  }
  function refreshCartPage() {
    if (!/^\/cart(\/|$|\?)/.test(location.pathname)) return Promise.resolve();
    var host = document.querySelector('#shopify-section-main-cart')
      || document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
    if (!host || !host.id) return Promise.resolve();
    var sid = host.id.replace(/^shopify-section-/, '');
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(sid),
      { credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(host.id) || doc.body.firstElementChild;
        if (fresh && fresh.innerHTML !== host.innerHTML) host.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }
  function refreshCount(cart) {
    var n = cart && typeof cart.item_count === 'number' ? String(cart.item_count) : null;
    if (n === null) return;
    var scopes = document.querySelectorAll('[data-js-cart-icon], [data-cart-count], [data-js-cart-count], .cart-count, .header__cart-count, #CartCount');
    Array.prototype.forEach.call(scopes, function (scope) {
      if (!scope.children.length && /^\s*\d+\s*$/.test(scope.textContent)) { scope.textContent = n; return; }
      Array.prototype.forEach.call(scope.querySelectorAll('*'), function (el) {
        if (!el.children.length && /^\s*\d+\s*$/.test(el.textContent)) el.textContent = n;
      });
    });
  }
  function refreshCartUI() {
    try { document.dispatchEvent(new CustomEvent('apps:product-added-to-cart')); } catch (e) {}
    window.__rastahGwpCart = null;
    return Promise.all([refreshDrawer(), refreshCartPage(), getCart().catch(function () { return null; })])
      .then(function (res) { if (res && res[2]) refreshCount(res[2]); })
      .catch(function () {})
      .then(function () {
        window.__rastahGwpCart = null;
        try {
          document.dispatchEvent(new CustomEvent('rastah-collgift:changed'));
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('quick-cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (e) {}
      });
  }

  function addGift(o) {
    var props = {}; props[PROP] = o.handle;
    lastAddAt = Date.now();
    console.info('[rastah-collgift] adding gift', o.handle, 'variant', o.gift.variant);
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: o.gift.variant, quantity: o.gift_qty || 1, properties: props })
    }).then(function (r) {
      if (r && !r.ok) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          window.__rastahCollLastError = { status: r.status, message: (j && (j.description || j.message)) || '', variant: o.gift.variant, offer: o.handle, ts: Date.now() };
          console.warn('[rastah-collgift] add failed', r.status, j);
          ST.adds[o.handle] = MAX_ADDS;
          window.__rastahCollStalled[o.handle] = true;
          saveState();
        });
      }
      ST.seen[o.handle] = true;
      saveState();
    }).catch(function (err) {
      window.__rastahCollLastError = { status: 0, message: String(err && err.message || err), variant: o.gift.variant, offer: o.handle, ts: Date.now() };
    });
  }
  function changeLine(key, qty, reason) {
    console.info('[rastah-collgift] set gift line', key, '->', qty, '-', reason || '');
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).catch(function () {});
  }

  function mkey(h) { return 'rastah_coll_members_' + h; }
  function cached(h) {
    var m = members[h];
    if (m && (Date.now() - m.t) < TTL) return m.set;
    try {
      var raw = sessionStorage.getItem(mkey(h));
      if (raw) {
        var o = JSON.parse(raw);
        if (o && o.ids && (Date.now() - o.t) < TTL) {
          var s = new Set(o.ids);
          members[h] = { t: o.t, set: s };
          return s;
        }
      }
    } catch (e) {}
    return null;
  }
  function fetchMembers(h) {
    var ids = [], failed = false;
    function pg(p) {
      return fetch('/collections/' + encodeURIComponent(h) + '/products.json?limit=250&page=' + p,
        { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) { failed = true; return { products: [] }; } return r.json(); })
        .then(function (j) {
          var pr = (j && j.products) || [];
          pr.forEach(function (x) { ids.push(x.id); });
          if (pr.length === 250 && p < PAGES) return pg(p + 1);
        })
        .catch(function () { failed = true; });
    }
    return pg(1).then(function () {
      if (failed) return null;
      var s = new Set(ids), t = Date.now();
      members[h] = { t: t, set: s };
      try { sessionStorage.setItem(mkey(h), JSON.stringify({ t: t, ids: ids })); } catch (e) {}
      if (!ids.length) console.warn('[rastah-collgift] collection "' + h + '" has no products; offers scoped to it can never qualify.');
      return s;
    });
  }
  function ensure(list) {
    var need = {};
    list.forEach(function (o) {
      if (o.whole_store) return;
      (o.collections || []).forEach(function (c) { if (c && c.handle && !cached(c.handle)) need[c.handle] = true; });
    });
    var hs = Object.keys(need);
    if (!hs.length) return Promise.resolve();
    return Promise.all(hs.map(fetchMembers));
  }
  function ready(o) {
    if (o.whole_store) return true;
    var ok = true;
    (o.collections || []).forEach(function (c) { if (!cached(c.handle)) ok = false; });
    return ok;
  }
  function spend(o, cart) {
    var t = 0, counted = 0, skipped = 0;
    cart.items.forEach(function (it) {
      if (ours(it)) return;
      var amt = (typeof it.final_line_price === 'number') ? it.final_line_price : it.line_price;
      if (o.whole_store) { t += amt; counted++; return; }
      var inn = false;
      (o.collections || []).forEach(function (c) {
        if (inn) return;
        var s = cached(c.handle);
        if (s && s.has(it.product_id)) inn = true;
      });
      if (inn) { t += amt; counted++; } else skipped++;
    });
    /* the commonest "it never unlocks" cause: everything in the cart is
       outside the qualifying collection. Say so plainly. */
    if (!o.whole_store && counted === 0 && skipped > 0) {
      console.info('[rastah-collgift] offer "' + o.handle + '": none of the ' + skipped
        + ' item(s) in the cart belong to its qualifying collection(s), so spend is 0.');
    }
    return t;
  }

  function reconcile() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;
    var list = offers();
    if (!list.length) { busy = false; return Promise.resolve(); }
    return getCart().then(function (cart) {
      return ensure(list).then(function () {
        var chain = Promise.resolve(), changed = false;
        list.forEach(function (o) {
          if (ST.blocked.indexOf(o.handle) !== -1) return;
          if (o.auto_add === false) return;
          if (!ready(o)) { console.warn('[rastah-collgift] membership not loaded for', o.handle, '- skipping this pass'); return; }

          var lines = [], otherGift = false;
          cart.items.forEach(function (it) {
            if (ours(it) && it.properties[PROP] === o.handle) lines.push(it);
            else if (o.gift && it.product_id === o.gift.id) otherGift = true;
          });

          var sp = spend(o, cart);
          var goal = minFor(o);
          var ok = sp >= goal;
          var want = o.gift_qty || 1;

          var charged = lines.filter(function (l) { return l.final_price > 0; });
          if (charged.length) {
            console.error('[rastah-collgift] offer "' + o.handle + '": gift "' + o.gift.title + '" is CHARGED '
              + (charged[0].final_price / 100) + ' - no active Shopify BXGY discount covers it at this cart value. '
              + 'Removing and disabling for this session.');
            block(o.handle);
            changed = true;
            lines.forEach(function (l) { chain = chain.then(function () { return changeLine(l.key, 0, 'gift not discounted to zero'); }); });
            return;
          }

          if (lines.length) {
            if (!ok) {
              changed = true;
              lines.forEach(function (l) { chain = chain.then(function () { return changeLine(l.key, 0, 'spend ' + (sp / 100) + ' < min ' + (goal / 100)); }); });
              return;
            }
            lines.forEach(function (l, i) {
              var target = (i === 0) ? want : 0;
              if (l.quantity !== target) {
                changed = true;
                chain = chain.then(function () { return changeLine(l.key, target, 'quantity lock'); });
              }
            });
            ST.adds[o.handle] = 0; saveState();
            return;
          }

          if (!ok) return;
          if (otherGift) { console.info('[rastah-collgift] gift product already in cart for', o.handle, '- not adding a second'); return; }
          if (ST.dismissed[o.handle]) return;
          if (ST.seen[o.handle]) {
            ST.dismissed[o.handle] = true;
            window.__rastahCollStalled[o.handle] = true;
            saveState();
            console.info('[rastah-collgift] gift was removed by the customer -', o.handle, 'dormant for this session');
            return;
          }
          if ((ST.adds[o.handle] || 0) >= MAX_ADDS) {
            window.__rastahCollStalled[o.handle] = true;
            console.warn('[rastah-collgift] breaker tripped', o.handle);
            return;
          }
          if (Date.now() - lastAddAt < COOLDOWN) return;
          ST.adds[o.handle] = (ST.adds[o.handle] || 0) + 1;
          saveState();
          changed = true;
          chain = chain.then(function () { return addGift(o); });
        });
        return chain.then(function () { if (changed) return refreshCartUI(); });
      });
    }).catch(function () {}).then(function () {
      busy = false;
      if (queued) { queued = false; return reconcile(); }
    });
  }

  var RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var _f = window.fetch;
  window.fetch = function (input) {
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var p = _f.apply(this, arguments);
    if (RE.test(url) && !busy) { p.then(function (res) { setTimeout(reconcile, 120); return res; }).catch(function () {}); }
    return p;
  };
  var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__cgSyncUrl = url || ''; return XO.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (RE.test(String(this.__cgSyncUrl || ''))) this.addEventListener('loadend', function () { setTimeout(reconcile, 120); });
    return XS.apply(this, arguments);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 400); });
  else setTimeout(reconcile, 400);

  window.rastahCollGiftSync = reconcile;
  window.rastahCollRefreshCart = refreshCartUI;
  window.__rastahCollMembers = members;
  window.__rastahCollReset = function () {
    ST = { blocked: [], adds: {}, dismissed: {}, seen: {} };
    window.__rastahCollBlocked = ST.blocked;
    window.__rastahCollStalled = {};
    saveState();
    console.info('[rastah-collgift] session state cleared - reload to re-evaluate');
  };
  /* Tells you, per offer, exactly why it has or has not unlocked. */
  window.__rastahCollDebug = function () {
    return getCart().then(function (cart) {
      var out = [];
      offers().forEach(function (o) {
        var sp = spend(o, cart);
        out.push({
          offer: o.handle,
          scope: o.whole_store ? 'whole store' : (o.collections || []).map(function (c) { return c.handle; }).join(', '),
          qualifyingSpend: sp / 100,
          threshold: minFor(o) / 100,
          currency: cart.currency,
          unlocked: sp >= minFor(o),
          giftInCart: cart.items.some(function (it) { return ours(it) && it.properties[PROP] === o.handle; }),
          blocked: ST.blocked.indexOf(o.handle) !== -1,
          dismissed: !!ST.dismissed[o.handle]
        });
      });
      console.table(out);
      return out;
    });
  };
})();
